import { AxiosResponse } from "axios";
import axios, { APIWrapperResponse, DefaultResponse } from "../general/HttpClient";
import { LeagueViewModel } from "../leagues/LeaguesStore";
import { SeasonViewModel } from "../seasons/SeasonsStore";
import { StatViewModel } from "../stats/StatsStore";
import { TeamViewModel } from "../teams/TeamsStore";

export function getSeedMatches(archived) {
    return axios.get("/api/SeedMatches/getSeedMatches", { params: { archived } }).then((response: AxiosResponse<APIWrapperResponse<Array<SeedMatchViewModel>>>) => {
        return response.data.result;
    });
}

export function getTeamSeedMatches(id) {
    return axios.get(`/api/SeedMatches/getTeamSeedMatches/${id}`).then((response: AxiosResponse<APIWrapperResponse<Array<SeedMatchViewModel>>>) => {
        return response.data.result;
    });
}

export function getAliasSeedMatches(id) {
    return axios.get(`/api/SeedMatches/getAliasSeedMatches/${id}`).then((response: AxiosResponse<APIWrapperResponse<Array<SeedMatchViewModel>>>) => {
        return response.data.result;
    });
}

export function getSeedMatch(id) {
    return axios.get(`/api/SeedMatches/getSeedMatch/${id}`).then((response: AxiosResponse<APIWrapperResponse<SeedMatchViewModel>>) => {
        return response.data.result;
    });
}

export function createSeedMatch(request: CreateSeedMatchRequest) {
    return axios.post(`/api/SeedMatches/createSeedMatch`, request).then((response: AxiosResponse<APIWrapperResponse<CreateSeedMatchResponse>>) => {
        return response.data.result;
    });
}

export function updateSeedMatch(request: UpdateSeedMatchRequest) {
    return axios.put(`/api/SeedMatches/updateSeedMatch`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function addParticipant(request: AddSeedMatchParticipantRequest) {
    return axios.post(`/api/SeedMatches/addParticipant`, request).then((response: AxiosResponse<APIWrapperResponse<AddSeedMatchParticipantResponse>>) => {
        return response.data.result;
    });
}

export function removeParticipant(request: RemoveSeedMatchParticipantRequest) {
    return axios.post(`/api/SeedMatches/removeParticipant`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function addStat(request: AddSeedMatchStatRequest) {
    return axios.post(`/api/SeedMatches/addStat`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function removeStat(request: RemoveSeedMatchStatRequest) {
    return axios.post(`/api/SeedMatches/removeStat`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}
export function updateSeedMatchStat(request: UpdateSeedMatchStatRequest) {
    return axios.post(`/api/SeedMatches/updateStat`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function resetStats(request: ResetStatsRequest) {
    return axios.post(`/api/SeedMatches/resetStats`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export class SeedMatchViewModel {
    constructor() {
        this.participants = [] as Array<SeedMatchParticipantViewModel>;
    }
    id: string;
    organizationID: string;
    name: string;
    date: string;
    isPublic: boolean;
    archived: boolean;
    rounds: number;
    participants: SeedMatchParticipantViewModel[];
}

export interface SeedMatchParticipantViewModel {
    id: string;
    teamID: string;
    team: TeamViewModel;
    seed: number;
    stats: SeedMatchStatViewModel[];
}

export interface SeedMatchStatViewModel {
    id: string;
    value: number;
    participantID: string;
    round: number;
    statID: string;
    stat: StatViewModel;
}

export interface AddSeedMatchParticipantRequest {
    teamID: string;
    seedMatchID: string;
}

export interface AddSeedMatchParticipantResponse extends DefaultResponse {
    participantID: string;
}

export interface AddSeedMatchStatRequest {
    seedMatchID: string;
    participantID: string;
    statID: string;
    value: number;
    round: number;
}

export interface CreateSeedMatchRequest {
    participantIDs: string[];
    name: string;
    organizationID: string;
    date: string;
    isPublic: boolean;
    rounds: number;
}

export interface CreateSeedMatchResponse extends DefaultResponse {
    seedMatchID: string;
}

export interface RemoveSeedMatchParticipantRequest {
    seedMatchID: string;
    teamID: string;
}

export interface RemoveSeedMatchStatRequest {
    seedMatchID: string;
    seedMatchStatID: string;
}

export interface UpdateSeedMatchRequest {
    id: string;
    name: string;
    date: string;
    rounds: number;
    isPublic: boolean;
    archived: boolean;
}

export interface UpdateSeedMatchStatRequest {
    seedMatchID: string;
    seedMatchStatID: string;
    value: number;
}

export interface ParticipantStatSummary {
    id: string;
    team: TeamViewModel;
    stats: { [round: string]: SeedMatchStatViewModel[] };
    Total: StatSummary;
}

export interface StatSummary {
    [stat: string]: SeedMatchStatViewModel;
}

export interface ResetStatsRequest {
    seedMatchID: string;
}
